import { BookingRateFilter, useBookingStore } from '~~/domains/booking';
import type { AvailableRoom } from '~~/domains/graphql';

export function useFilteredAvailableRoomOffers(
  availableRooms: Ref<AvailableRoom[] | undefined>,
) {
  const bookingStore = useBookingStore();

  return computed<AvailableRoom[]>(() => {
    if (!Array.isArray(availableRooms.value)) return [];

    return availableRooms.value.map(availableRoom => {
      if (bookingStore.numberOfRooms <= 1) return availableRoom;

      const room = JSON.parse(JSON.stringify(availableRoom)) as AvailableRoom;

      if (
        room.availabilityRoom &&
        Array.isArray(room.availabilityRoom.offers)
      ) {
        room.availabilityRoom.offers = room.availabilityRoom.offers.filter(
          offer =>
            (offer?.categories || []).some(
              category =>
                category?.code === BookingRateFilter.Standard ||
                category?.code === BookingRateFilter.Preferred,
            ),
        );
      }

      return room;
    });
  });
}
